module.exports = "<div ng-class=\"['toast-wrap', {hidden: $ctrl.hidden}]\" ng-transclude></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/adpToast/adpToast.html
// module id = 639
// module chunks = 0